// Council data for 31 Melbourne Metropolitan Councils
// Each council has unique, localised content for SEO

export const councilData = {
  "banyule": {
    name: "Banyule",
    slug: "banyule",
    region: "North-East Melbourne",
    suburbs: ["Heidelberg", "Ivanhoe", "Greensborough", "Bundoora", "Watsonia", "Rosanna"],
    solarAdoption: 28,
    annualSavings: 1850,
    billReduction: 65,
    batteryGrowth: 42,
    avgSystemSize: "6.6kW",
    avgBatterySize: "10kWh",
    housingType: "Established family homes with good roof space",
    description: "Banyule is one of Melbourne's leafiest suburbs with excellent solar potential. The combination of established homes, good roof orientations, and environmentally conscious residents makes it ideal for solar and battery adoption.",
    whySolar: "Banyule's tree-lined streets and established homes offer excellent conditions for solar. Many homes feature north-facing roofs ideal for solar generation, and the council's commitment to sustainability aligns perfectly with the growing demand for clean energy solutions.",
    projects: [
      { suburb: "Heidelberg", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Double-storey", savings: 1920, brand: "Jinko Solar + Tesla" },
      { suburb: "Ivanhoe", systemSize: "8kW", batterySize: "13.5kWh", homeType: "Single-storey", savings: 2150, brand: "Jinko Solar + Tesla Powerwall" },
      { suburb: "Greensborough", systemSize: "10kW", batterySize: "10kWh", homeType: "Double-storey", savings: 2400, brand: "Jinko Solar + WHES" }
    ]
  },
  "bayside": {
    name: "Bayside",
    slug: "bayside",
    region: "South-East Melbourne",
    suburbs: ["Brighton", "Sandringham", "Hampton", "Beaumaris", "Black Rock", "Cheltenham"],
    solarAdoption: 32,
    annualSavings: 2100,
    billReduction: 70,
    batteryGrowth: 48,
    avgSystemSize: "8kW",
    avgBatterySize: "13.5kWh",
    housingType: "Premium homes with large roof areas",
    description: "Bayside's affluent suburbs feature larger homes with substantial roof space, making it one of the highest solar adoption areas in Melbourne. Battery storage is particularly popular for energy independence.",
    whySolar: "Bayside residents are leading Melbourne's clean energy transition. With larger homes, higher energy consumption, and a strong environmental consciousness, solar and battery systems deliver exceptional returns in this area.",
    projects: [
      { suburb: "Brighton", systemSize: "10kW", batterySize: "13.5kWh", homeType: "Double-storey", savings: 2800, brand: "Jinko Solar + Tesla Powerwall" },
      { suburb: "Sandringham", systemSize: "8kW", batterySize: "10kWh", homeType: "Single-storey", savings: 2200, brand: "Jinko Solar + Deye" },
      { suburb: "Hampton", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Double-storey", savings: 1950, brand: "Jinko Solar + WHES" }
    ]
  },
  "boroondara": {
    name: "Boroondara",
    slug: "boroondara",
    region: "Inner-East Melbourne",
    suburbs: ["Hawthorn", "Kew", "Camberwell", "Balwyn", "Canterbury", "Glen Iris"],
    solarAdoption: 26,
    annualSavings: 1950,
    billReduction: 62,
    batteryGrowth: 45,
    avgSystemSize: "7kW",
    avgBatterySize: "10kWh",
    housingType: "Heritage and modern homes",
    description: "Boroondara combines heritage charm with modern sustainability. Many residents are retrofitting solar onto period homes while new builds incorporate solar-ready designs.",
    whySolar: "Despite heritage considerations, Boroondara has embraced solar with innovative installation approaches. The council's sustainability initiatives and residents' commitment to reducing emissions drive strong adoption rates.",
    projects: [
      { suburb: "Hawthorn", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Period home", savings: 1850, brand: "Jinko Solar + Tesla" },
      { suburb: "Kew", systemSize: "8kW", batterySize: "13.5kWh", homeType: "Double-storey", savings: 2300, brand: "Jinko Solar + Sigenergy" },
      { suburb: "Camberwell", systemSize: "10kW", batterySize: "10kWh", homeType: "Modern home", savings: 2500, brand: "Jinko Solar + Deye" }
    ]
  },
  "brimbank": {
    name: "Brimbank",
    slug: "brimbank",
    region: "Western Melbourne",
    suburbs: ["Sunshine", "St Albans", "Deer Park", "Keilor", "Sydenham", "Cairnlea"],
    solarAdoption: 35,
    annualSavings: 1650,
    billReduction: 68,
    batteryGrowth: 38,
    avgSystemSize: "6.6kW",
    avgBatterySize: "10kWh",
    housingType: "Mix of established and new estates",
    description: "Brimbank has one of the highest solar adoption rates in Melbourne's west. Affordable housing and strong community networks have driven rapid uptake of solar systems.",
    whySolar: "Brimbank residents are savvy about energy costs. The combination of newer homes with good roof space and a community focused on practical savings makes this area ideal for solar investment.",
    projects: [
      { suburb: "Sunshine", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Single-storey", savings: 1750, brand: "Jinko Solar + Deye" },
      { suburb: "St Albans", systemSize: "6.6kW", batterySize: null, homeType: "Double-storey", savings: 1400, brand: "Jinko Solar" },
      { suburb: "Deer Park", systemSize: "8kW", batterySize: "10kWh", homeType: "Single-storey", savings: 1950, brand: "Jinko Solar + WHES" }
    ]
  },
  "cardinia": {
    name: "Cardinia",
    slug: "cardinia",
    region: "South-East Growth Corridor",
    suburbs: ["Pakenham", "Officer", "Beaconsfield", "Emerald", "Cockatoo", "Gembrook"],
    solarAdoption: 38,
    annualSavings: 1800,
    billReduction: 72,
    batteryGrowth: 52,
    avgSystemSize: "6.6kW",
    avgBatterySize: "10kWh",
    housingType: "New estates and rural properties",
    description: "Cardinia is Melbourne's fastest-growing region with new homes designed for solar. The mix of suburban estates and semi-rural properties creates diverse solar opportunities.",
    whySolar: "New homes in Cardinia are increasingly built solar-ready. Combined with larger blocks and minimal shading, residents can maximise solar generation and enjoy significant savings.",
    projects: [
      { suburb: "Pakenham", systemSize: "6.6kW", batterySize: "10kWh", homeType: "New build", savings: 1850, brand: "Jinko Solar + Deye" },
      { suburb: "Officer", systemSize: "8kW", batterySize: "13.5kWh", homeType: "Double-storey", savings: 2200, brand: "Jinko Solar + Tesla Powerwall" },
      { suburb: "Beaconsfield", systemSize: "10kW", batterySize: "10kWh", homeType: "Rural property", savings: 2600, brand: "Jinko Solar + WHES" }
    ]
  },
  "casey": {
    name: "Casey",
    slug: "casey",
    region: "South-East Melbourne",
    suburbs: ["Cranbourne", "Narre Warren", "Berwick", "Clyde", "Hampton Park", "Hallam"],
    solarAdoption: 42,
    annualSavings: 1750,
    billReduction: 70,
    batteryGrowth: 45,
    avgSystemSize: "6.6kW",
    avgBatterySize: "10kWh",
    housingType: "Family homes in growth suburbs",
    description: "Casey is Victoria's most populous municipality and a solar leader. The rapid growth of new housing estates has created a community of solar-savvy homeowners.",
    whySolar: "With one of the highest solar adoption rates in Victoria, Casey residents understand the value of solar. New estates feature optimal roof designs, and the family-focused community prioritises long-term savings.",
    projects: [
      { suburb: "Cranbourne", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Single-storey", savings: 1800, brand: "Jinko Solar + Deye" },
      { suburb: "Berwick", systemSize: "8kW", batterySize: "13.5kWh", homeType: "Double-storey", savings: 2150, brand: "Jinko Solar + Tesla" },
      { suburb: "Hampton Park", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Single-storey", savings: 1650, brand: "Jinko Solar + WHES" }
    ]
  },
  "darebin": {
    name: "Darebin",
    slug: "darebin",
    region: "Northern Melbourne",
    suburbs: ["Preston", "Reservoir", "Northcote", "Thornbury", "Fairfield", "Alphington"],
    solarAdoption: 24,
    annualSavings: 1700,
    billReduction: 58,
    batteryGrowth: 40,
    avgSystemSize: "5kW",
    avgBatterySize: "10kWh",
    housingType: "Mix of period homes and units",
    description: "Darebin's diverse housing stock includes everything from Victorian terraces to modern apartments. The council's strong environmental policies have encouraged solar adoption across all property types.",
    whySolar: "Darebin Council is a climate leader, and residents share this commitment. Despite smaller roof spaces in some areas, innovative installation solutions are helping more homes go solar.",
    projects: [
      { suburb: "Preston", systemSize: "5kW", batterySize: "10kWh", homeType: "Period home", savings: 1550, brand: "Jinko Solar + Sigenergy" },
      { suburb: "Northcote", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Renovated terrace", savings: 1800, brand: "Jinko Solar + Deye" },
      { suburb: "Reservoir", systemSize: "6.6kW", batterySize: null, homeType: "Single-storey", savings: 1350, brand: "Jinko Solar" }
    ]
  },
  "frankston": {
    name: "Frankston",
    slug: "frankston",
    region: "South-East Melbourne",
    suburbs: ["Frankston", "Frankston South", "Langwarrin", "Carrum Downs", "Seaford", "Karingal"],
    solarAdoption: 34,
    annualSavings: 1800,
    billReduction: 68,
    batteryGrowth: 44,
    avgSystemSize: "6.6kW",
    avgBatterySize: "10kWh",
    housingType: "Coastal and suburban homes",
    description: "Frankston's bayside location and mix of established and new suburbs make it ideal for solar. The coastal lifestyle aligns perfectly with sustainable energy choices.",
    whySolar: "Frankston residents enjoy excellent sun exposure and a lifestyle that values sustainability. From beachside homes to family estates, solar delivers consistent savings across the municipality.",
    projects: [
      { suburb: "Frankston South", systemSize: "8kW", batterySize: "13.5kWh", homeType: "Coastal home", savings: 2100, brand: "Jinko Solar + Tesla Powerwall" },
      { suburb: "Langwarrin", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Single-storey", savings: 1750, brand: "Jinko Solar + Deye" },
      { suburb: "Carrum Downs", systemSize: "6.6kW", batterySize: "10kWh", homeType: "New build", savings: 1800, brand: "Jinko Solar + WHES" }
    ]
  },
  "glen-eira": {
    name: "Glen Eira",
    slug: "glen-eira",
    region: "South-East Melbourne",
    suburbs: ["Bentleigh", "Carnegie", "Caulfield", "Elsternwick", "Glen Huntly", "Murrumbeena"],
    solarAdoption: 25,
    annualSavings: 1850,
    billReduction: 60,
    batteryGrowth: 42,
    avgSystemSize: "6kW",
    avgBatterySize: "10kWh",
    housingType: "Mix of houses and apartments",
    description: "Glen Eira's established suburbs feature a mix of family homes and medium-density housing. Solar adoption is growing as residents seek to reduce costs and environmental impact.",
    whySolar: "Glen Eira's proximity to the city and diverse housing options make it a growing solar market. Residents appreciate the combination of savings and sustainability that solar provides.",
    projects: [
      { suburb: "Bentleigh", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Family home", savings: 1900, brand: "Jinko Solar + Sigenergy" },
      { suburb: "Carnegie", systemSize: "5kW", batterySize: "10kWh", homeType: "Townhouse", savings: 1600, brand: "Jinko Solar + Deye" },
      { suburb: "Caulfield", systemSize: "6.6kW", batterySize: null, homeType: "Period home", savings: 1400, brand: "Jinko Solar" }
    ]
  },
  "greater-dandenong": {
    name: "Greater Dandenong",
    slug: "greater-dandenong",
    region: "South-East Melbourne",
    suburbs: ["Dandenong", "Noble Park", "Springvale", "Keysborough", "Lynbrook", "Bangholme"],
    solarAdoption: 36,
    annualSavings: 1650,
    billReduction: 70,
    batteryGrowth: 40,
    avgSystemSize: "6.6kW",
    avgBatterySize: "10kWh",
    housingType: "Suburban family homes",
    description: "Greater Dandenong has embraced solar as a practical way to manage household costs. The diverse community has driven strong adoption rates across all suburbs.",
    whySolar: "Greater Dandenong residents understand the value of reducing energy costs. With a mix of established and newer homes, solar systems are delivering significant savings across the municipality.",
    projects: [
      { suburb: "Keysborough", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Single-storey", savings: 1750, brand: "Jinko Solar + Deye" },
      { suburb: "Noble Park", systemSize: "6.6kW", batterySize: null, homeType: "Double-storey", savings: 1350, brand: "Jinko Solar" },
      { suburb: "Springvale", systemSize: "8kW", batterySize: "10kWh", homeType: "Family home", savings: 1950, brand: "Jinko Solar + WHES" }
    ]
  },
  "hobsons-bay": {
    name: "Hobsons Bay",
    slug: "hobsons-bay",
    region: "Western Melbourne",
    suburbs: ["Williamstown", "Altona", "Newport", "Spotswood", "Laverton", "Seabrook"],
    solarAdoption: 29,
    annualSavings: 1800,
    billReduction: 64,
    batteryGrowth: 46,
    avgSystemSize: "6.6kW",
    avgBatterySize: "10kWh",
    housingType: "Bayside and suburban homes",
    description: "Hobsons Bay combines coastal charm with strong environmental values. The council's sustainability initiatives have encouraged widespread solar adoption.",
    whySolar: "Hobsons Bay's bayside suburbs enjoy excellent sun exposure, and the community's environmental consciousness drives strong demand for solar and battery systems.",
    projects: [
      { suburb: "Williamstown", systemSize: "6.6kW", batterySize: "13.5kWh", homeType: "Period home", savings: 1950, brand: "Jinko Solar + Tesla Powerwall" },
      { suburb: "Altona", systemSize: "8kW", batterySize: "10kWh", homeType: "Family home", savings: 2050, brand: "Jinko Solar + Deye" },
      { suburb: "Newport", systemSize: "5kW", batterySize: "10kWh", homeType: "Townhouse", savings: 1650, brand: "Jinko Solar + Sigenergy" }
    ]
  },
  "hume": {
    name: "Hume",
    slug: "hume",
    region: "Northern Melbourne",
    suburbs: ["Craigieburn", "Broadmeadows", "Sunbury", "Gladstone Park", "Roxburgh Park", "Greenvale"],
    solarAdoption: 40,
    annualSavings: 1700,
    billReduction: 72,
    batteryGrowth: 48,
    avgSystemSize: "6.6kW",
    avgBatterySize: "10kWh",
    housingType: "New estates and established suburbs",
    description: "Hume is one of Melbourne's fastest-growing municipalities with excellent solar adoption. New housing estates are designed with solar in mind.",
    whySolar: "Hume's rapid growth has created a community of new homeowners who understand the value of solar from day one. The combination of new homes and hot summer days makes solar a smart investment.",
    projects: [
      { suburb: "Craigieburn", systemSize: "6.6kW", batterySize: "10kWh", homeType: "New build", savings: 1800, brand: "Jinko Solar + Deye" },
      { suburb: "Greenvale", systemSize: "8kW", batterySize: "13.5kWh", homeType: "Double-storey", savings: 2100, brand: "Jinko Solar + Sigenergy" },
      { suburb: "Sunbury", systemSize: "10kW", batterySize: "10kWh", homeType: "Rural property", savings: 2400, brand: "Jinko Solar + WHES" }
    ]
  },
  "kingston": {
    name: "Kingston",
    slug: "kingston",
    region: "South-East Melbourne",
    suburbs: ["Cheltenham", "Moorabbin", "Mentone", "Mordialloc", "Clayton South", "Parkdale"],
    solarAdoption: 30,
    annualSavings: 1850,
    billReduction: 66,
    batteryGrowth: 44,
    avgSystemSize: "6.6kW",
    avgBatterySize: "10kWh",
    housingType: "Established bayside suburbs",
    description: "Kingston's bayside suburbs combine established homes with newer developments. The council's environmental initiatives support strong solar uptake.",
    whySolar: "Kingston residents enjoy the benefits of bayside living and increasingly, bayside solar. With good sun exposure and a community focused on sustainability, solar is a natural choice.",
    projects: [
      { suburb: "Cheltenham", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Family home", savings: 1850, brand: "Jinko Solar + Deye" },
      { suburb: "Mentone", systemSize: "8kW", batterySize: "13.5kWh", homeType: "Double-storey", savings: 2150, brand: "Jinko Solar + Tesla Powerwall" },
      { suburb: "Mordialloc", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Coastal home", savings: 1900, brand: "Jinko Solar + WHES" }
    ]
  },
  "knox": {
    name: "Knox",
    slug: "knox",
    region: "Eastern Melbourne",
    suburbs: ["Wantirna", "Boronia", "Ferntree Gully", "Rowville", "Scoresby", "Knoxfield"],
    solarAdoption: 33,
    annualSavings: 1800,
    billReduction: 68,
    batteryGrowth: 46,
    avgSystemSize: "6.6kW",
    avgBatterySize: "10kWh",
    housingType: "Family homes near the Dandenongs",
    description: "Knox's proximity to the Dandenong Ranges creates a unique environment where residents value both nature and sustainable living. Solar adoption is strong across all suburbs.",
    whySolar: "Knox residents appreciate their natural surroundings and increasingly choose solar to reduce their environmental impact. The mix of established and newer homes provides excellent solar opportunities.",
    projects: [
      { suburb: "Wantirna", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Family home", savings: 1800, brand: "Jinko Solar + Deye" },
      { suburb: "Rowville", systemSize: "8kW", batterySize: "13.5kWh", homeType: "Double-storey", savings: 2100, brand: "Jinko Solar + Sigenergy" },
      { suburb: "Ferntree Gully", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Hills home", savings: 1850, brand: "Jinko Solar + WHES" }
    ]
  },
  "manningham": {
    name: "Manningham",
    slug: "manningham",
    region: "Eastern Melbourne",
    suburbs: ["Doncaster", "Templestowe", "Bulleen", "Donvale", "Warrandyte", "Park Orchards"],
    solarAdoption: 31,
    annualSavings: 2000,
    billReduction: 66,
    batteryGrowth: 50,
    avgSystemSize: "8kW",
    avgBatterySize: "13.5kWh",
    housingType: "Premium homes with large blocks",
    description: "Manningham's leafy suburbs feature larger homes with excellent solar potential. The community's focus on quality extends to their choice of solar systems.",
    whySolar: "Manningham residents invest in quality solar systems that match their premium homes. Larger roof spaces and higher energy consumption mean excellent returns on solar investment.",
    projects: [
      { suburb: "Doncaster", systemSize: "10kW", batterySize: "13.5kWh", homeType: "Large family home", savings: 2400, brand: "Jinko Solar + Tesla Powerwall" },
      { suburb: "Templestowe", systemSize: "8kW", batterySize: "13.5kWh", homeType: "Double-storey", savings: 2200, brand: "Jinko Solar + Sigenergy" },
      { suburb: "Warrandyte", systemSize: "10kW", batterySize: "10kWh", homeType: "Rural property", savings: 2500, brand: "Jinko Solar + WHES" }
    ]
  },
  "maribyrnong": {
    name: "Maribyrnong",
    slug: "maribyrnong",
    region: "Inner-West Melbourne",
    suburbs: ["Footscray", "Yarraville", "Seddon", "Maribyrnong", "West Footscray", "Braybrook"],
    solarAdoption: 22,
    annualSavings: 1650,
    billReduction: 55,
    batteryGrowth: 38,
    avgSystemSize: "5kW",
    avgBatterySize: "10kWh",
    housingType: "Inner-city mix of homes and units",
    description: "Maribyrnong's inner-city suburbs are experiencing a solar revolution. Despite smaller blocks, residents are finding innovative ways to harness solar power.",
    whySolar: "Maribyrnong's progressive community leads the way in urban solar adoption. From renovated terraces to new apartments, solar is becoming standard across the municipality.",
    projects: [
      { suburb: "Yarraville", systemSize: "5kW", batterySize: "10kWh", homeType: "Renovated terrace", savings: 1600, brand: "Jinko Solar + Sigenergy" },
      { suburb: "Footscray", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Family home", savings: 1800, brand: "Jinko Solar + Deye" },
      { suburb: "Seddon", systemSize: "5kW", batterySize: null, homeType: "Period home", savings: 1300, brand: "Jinko Solar" }
    ]
  },
  "maroondah": {
    name: "Maroondah",
    slug: "maroondah",
    region: "Eastern Melbourne",
    suburbs: ["Ringwood", "Croydon", "Heathmont", "Bayswater", "Kilsyth", "Warranwood"],
    solarAdoption: 34,
    annualSavings: 1750,
    billReduction: 68,
    batteryGrowth: 44,
    avgSystemSize: "6.6kW",
    avgBatterySize: "10kWh",
    housingType: "Established suburban homes",
    description: "Maroondah's family-focused suburbs have embraced solar as a practical investment. The mix of established homes and new developments creates diverse solar opportunities.",
    whySolar: "Maroondah families understand that solar is a smart long-term investment. With good roof space and community support for sustainability, solar adoption continues to grow.",
    projects: [
      { suburb: "Ringwood", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Family home", savings: 1800, brand: "Jinko Solar + Deye" },
      { suburb: "Croydon", systemSize: "8kW", batterySize: "13.5kWh", homeType: "Double-storey", savings: 2050, brand: "Jinko Solar + Sigenergy" },
      { suburb: "Heathmont", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Single-storey", savings: 1750, brand: "Jinko Solar + WHES" }
    ]
  },
  "melbourne": {
    name: "Melbourne",
    slug: "melbourne",
    region: "Central Melbourne",
    suburbs: ["CBD", "Southbank", "Docklands", "Carlton", "North Melbourne", "Parkville"],
    solarAdoption: 18,
    annualSavings: 1500,
    billReduction: 50,
    batteryGrowth: 55,
    avgSystemSize: "5kW",
    avgBatterySize: "10kWh",
    housingType: "High-rise and medium-density",
    description: "Melbourne CBD and surrounds present unique solar opportunities. Rooftop solar on apartment buildings and commercial properties is growing rapidly.",
    whySolar: "Melbourne's central areas are innovating with solar solutions for high-density living. Battery storage is particularly popular for apartment buildings seeking energy independence.",
    projects: [
      { suburb: "Carlton", systemSize: "5kW", batterySize: "10kWh", homeType: "Terrace house", savings: 1450, brand: "Jinko Solar + Sigenergy" },
      { suburb: "North Melbourne", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Townhouse", savings: 1650, brand: "Jinko Solar + Deye" },
      { suburb: "Parkville", systemSize: "5kW", batterySize: "13.5kWh", homeType: "Period home", savings: 1550, brand: "Jinko Solar + Tesla" }
    ]
  },
  "melton": {
    name: "Melton",
    slug: "melton",
    region: "Western Growth Corridor",
    suburbs: ["Melton", "Caroline Springs", "Taylors Hill", "Rockbank", "Kurunjang", "Brookfield"],
    solarAdoption: 45,
    annualSavings: 1700,
    billReduction: 75,
    batteryGrowth: 50,
    avgSystemSize: "6.6kW",
    avgBatterySize: "10kWh",
    housingType: "New housing estates",
    description: "Melton has one of the highest solar adoption rates in Victoria. New housing estates are designed with solar as a standard feature.",
    whySolar: "Melton's new homeowners are solar champions. With purpose-built homes featuring optimal roof designs and the hot western suburbs climate, solar delivers exceptional returns.",
    projects: [
      { suburb: "Caroline Springs", systemSize: "6.6kW", batterySize: "10kWh", homeType: "New build", savings: 1800, brand: "Jinko Solar + Deye" },
      { suburb: "Taylors Hill", systemSize: "8kW", batterySize: "13.5kWh", homeType: "Double-storey", savings: 2100, brand: "Jinko Solar + WHES" },
      { suburb: "Melton", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Family home", savings: 1750, brand: "Jinko Solar + Sigenergy" }
    ]
  },
  "monash": {
    name: "Monash",
    slug: "monash",
    region: "South-East Melbourne",
    suburbs: ["Clayton", "Glen Waverley", "Mount Waverley", "Mulgrave", "Oakleigh", "Wheelers Hill"],
    solarAdoption: 32,
    annualSavings: 1900,
    billReduction: 66,
    batteryGrowth: 48,
    avgSystemSize: "6.6kW",
    avgBatterySize: "10kWh",
    housingType: "Established family suburbs",
    description: "Monash's diverse suburbs feature strong solar adoption driven by both environmental and economic motivations. The university precinct adds innovation to local solar approaches.",
    whySolar: "Monash residents are well-informed about solar benefits. The combination of research institutions, family values, and practical thinking drives smart solar investments.",
    projects: [
      { suburb: "Glen Waverley", systemSize: "8kW", batterySize: "13.5kWh", homeType: "Double-storey", savings: 2200, brand: "Jinko Solar + Tesla Powerwall" },
      { suburb: "Mount Waverley", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Family home", savings: 1850, brand: "Jinko Solar + Deye" },
      { suburb: "Wheelers Hill", systemSize: "10kW", batterySize: "10kWh", homeType: "Large home", savings: 2400, brand: "Jinko Solar + WHES" }
    ]
  },
  "moonee-valley": {
    name: "Moonee Valley",
    slug: "moonee-valley",
    region: "Inner-North Melbourne",
    suburbs: ["Essendon", "Moonee Ponds", "Ascot Vale", "Aberfeldie", "Strathmore", "Airport West"],
    solarAdoption: 26,
    annualSavings: 1750,
    billReduction: 60,
    batteryGrowth: 42,
    avgSystemSize: "6kW",
    avgBatterySize: "10kWh",
    housingType: "Mix of period and modern homes",
    description: "Moonee Valley's established suburbs are experiencing a solar transformation. Heritage homes and new builds alike are adopting solar solutions.",
    whySolar: "Moonee Valley residents value the combination of heritage charm and modern sustainability. Solar installations are carefully designed to complement the area's character.",
    projects: [
      { suburb: "Essendon", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Period home", savings: 1850, brand: "Jinko Solar + Sigenergy" },
      { suburb: "Moonee Ponds", systemSize: "5kW", batterySize: "10kWh", homeType: "Terrace", savings: 1600, brand: "Jinko Solar + Deye" },
      { suburb: "Strathmore", systemSize: "8kW", batterySize: "13.5kWh", homeType: "Family home", savings: 2050, brand: "Jinko Solar + Tesla" }
    ]
  },
  "merri-bek": {
    name: "Merri-bek",
    slug: "merri-bek",
    region: "Northern Melbourne",
    suburbs: ["Brunswick", "Coburg", "Pascoe Vale", "Glenroy", "Fawkner", "Hadfield"],
    solarAdoption: 27,
    annualSavings: 1700,
    billReduction: 62,
    batteryGrowth: 45,
    avgSystemSize: "5kW",
    avgBatterySize: "10kWh",
    housingType: "Inner-city diverse housing",
    description: "Merri-bek (formerly Moreland) leads with progressive environmental policies. The diverse community has embraced solar across all housing types.",
    whySolar: "Merri-bek's environmentally conscious community is at the forefront of Melbourne's clean energy transition. From Brunswick's cafes to Coburg's family homes, solar is everywhere.",
    projects: [
      { suburb: "Brunswick", systemSize: "5kW", batterySize: "10kWh", homeType: "Terrace", savings: 1550, brand: "Jinko Solar + Sigenergy" },
      { suburb: "Coburg", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Family home", savings: 1800, brand: "Jinko Solar + Deye" },
      { suburb: "Pascoe Vale", systemSize: "6.6kW", batterySize: null, homeType: "Single-storey", savings: 1400, brand: "Jinko Solar" }
    ]
  },
  "mornington-peninsula": {
    name: "Mornington Peninsula",
    slug: "mornington-peninsula",
    region: "South-East Victoria",
    suburbs: ["Mornington", "Frankston South", "Mount Martha", "Rosebud", "Sorrento", "Dromana"],
    solarAdoption: 35,
    annualSavings: 1900,
    billReduction: 70,
    batteryGrowth: 52,
    avgSystemSize: "8kW",
    avgBatterySize: "13.5kWh",
    housingType: "Coastal and rural properties",
    description: "The Mornington Peninsula's unique lifestyle drives strong demand for energy independence. Coastal homes and rural properties are ideal for solar and battery systems.",
    whySolar: "Peninsula residents value self-sufficiency and sustainability. The combination of holiday homes, permanent residents, and rural properties creates diverse solar opportunities.",
    projects: [
      { suburb: "Mornington", systemSize: "8kW", batterySize: "13.5kWh", homeType: "Coastal home", savings: 2150, brand: "Jinko Solar + Tesla Powerwall" },
      { suburb: "Mount Martha", systemSize: "10kW", batterySize: "13.5kWh", homeType: "Large property", savings: 2500, brand: "Jinko Solar + WHES" },
      { suburb: "Rosebud", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Holiday home", savings: 1800, brand: "Jinko Solar + Deye" }
    ]
  },
  "nillumbik": {
    name: "Nillumbik",
    slug: "nillumbik",
    region: "North-East Melbourne",
    suburbs: ["Eltham", "Diamond Creek", "Hurstbridge", "Research", "Kangaroo Ground", "Plenty"],
    solarAdoption: 38,
    annualSavings: 2100,
    billReduction: 72,
    batteryGrowth: 55,
    avgSystemSize: "10kW",
    avgBatterySize: "13.5kWh",
    housingType: "Rural and semi-rural properties",
    description: "Nillumbik's green wedge properties are perfect for solar. Large blocks, minimal shading, and environmentally conscious residents drive high adoption rates.",
    whySolar: "Nillumbik residents live surrounded by nature and naturally gravitate toward sustainable energy. Larger properties allow for bigger systems and greater energy independence.",
    projects: [
      { suburb: "Eltham", systemSize: "10kW", batterySize: "13.5kWh", homeType: "Hills home", savings: 2300, brand: "Jinko Solar + Tesla Powerwall" },
      { suburb: "Diamond Creek", systemSize: "8kW", batterySize: "10kWh", homeType: "Family home", savings: 2050, brand: "Jinko Solar + Sigenergy" },
      { suburb: "Hurstbridge", systemSize: "10kW", batterySize: "13.5kWh", homeType: "Rural property", savings: 2500, brand: "Jinko Solar + WHES" }
    ]
  },
  "port-phillip": {
    name: "Port Phillip",
    slug: "port-phillip",
    region: "Inner Melbourne",
    suburbs: ["St Kilda", "South Melbourne", "Albert Park", "Middle Park", "Elwood", "Balaclava"],
    solarAdoption: 20,
    annualSavings: 1600,
    billReduction: 52,
    batteryGrowth: 48,
    avgSystemSize: "5kW",
    avgBatterySize: "10kWh",
    housingType: "Inner-city period homes and apartments",
    description: "Port Phillip's bayside suburbs combine heritage architecture with progressive sustainability values. Solar solutions are tailored to the area's unique character.",
    whySolar: "Port Phillip residents lead Melbourne's urban sustainability movement. Despite heritage constraints, innovative solar solutions are bringing clean energy to this iconic area.",
    projects: [
      { suburb: "St Kilda", systemSize: "5kW", batterySize: "10kWh", homeType: "Period apartment", savings: 1500, brand: "Jinko Solar + Sigenergy" },
      { suburb: "Elwood", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Family home", savings: 1750, brand: "Jinko Solar + Deye" },
      { suburb: "Albert Park", systemSize: "5kW", batterySize: "13.5kWh", homeType: "Terrace", savings: 1650, brand: "Jinko Solar + Tesla" }
    ]
  },
  "stonnington": {
    name: "Stonnington",
    slug: "stonnington",
    region: "Inner-South Melbourne",
    suburbs: ["Malvern", "Toorak", "Prahran", "South Yarra", "Armadale", "Glen Iris"],
    solarAdoption: 24,
    annualSavings: 2200,
    billReduction: 58,
    batteryGrowth: 52,
    avgSystemSize: "8kW",
    avgBatterySize: "13.5kWh",
    housingType: "Premium heritage and modern homes",
    description: "Stonnington's prestigious suburbs feature larger homes with significant energy needs. Premium solar and battery systems are popular among quality-focused residents.",
    whySolar: "Stonnington residents invest in premium solar systems that match their homes' quality. Larger energy consumption means excellent returns on quality installations.",
    projects: [
      { suburb: "Malvern", systemSize: "10kW", batterySize: "13.5kWh", homeType: "Large family home", savings: 2600, brand: "Jinko Solar + Tesla Powerwall" },
      { suburb: "Toorak", systemSize: "10kW", batterySize: "13.5kWh", homeType: "Premium home", savings: 2800, brand: "Jinko Solar + Tesla Powerwall" },
      { suburb: "Armadale", systemSize: "8kW", batterySize: "10kWh", homeType: "Period home", savings: 2200, brand: "Jinko Solar + Sigenergy" }
    ]
  },
  "whitehorse": {
    name: "Whitehorse",
    slug: "whitehorse",
    region: "Eastern Melbourne",
    suburbs: ["Box Hill", "Blackburn", "Nunawading", "Mitcham", "Forest Hill", "Vermont"],
    solarAdoption: 30,
    annualSavings: 1850,
    billReduction: 65,
    batteryGrowth: 46,
    avgSystemSize: "6.6kW",
    avgBatterySize: "10kWh",
    housingType: "Established suburban homes",
    description: "Whitehorse's leafy eastern suburbs feature strong solar adoption. The community values both environmental benefits and practical savings.",
    whySolar: "Whitehorse families appreciate solar as a smart investment. The mix of established homes and new developments provides excellent opportunities for solar installation.",
    projects: [
      { suburb: "Box Hill", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Family home", savings: 1800, brand: "Jinko Solar + Deye" },
      { suburb: "Blackburn", systemSize: "8kW", batterySize: "13.5kWh", homeType: "Double-storey", savings: 2100, brand: "Jinko Solar + Sigenergy" },
      { suburb: "Vermont", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Single-storey", savings: 1850, brand: "Jinko Solar + WHES" }
    ]
  },
  "whittlesea": {
    name: "Whittlesea",
    slug: "whittlesea",
    region: "Northern Growth Corridor",
    suburbs: ["South Morang", "Mernda", "Doreen", "Epping", "Mill Park", "Lalor"],
    solarAdoption: 44,
    annualSavings: 1750,
    billReduction: 74,
    batteryGrowth: 50,
    avgSystemSize: "6.6kW",
    avgBatterySize: "10kWh",
    housingType: "New housing estates",
    description: "Whittlesea is one of Melbourne's fastest-growing areas with exceptional solar adoption. New homes are designed with solar as a priority.",
    whySolar: "Whittlesea's new homeowners understand solar from the start. Purpose-built homes with optimal roof designs and the growing community of solar advocates drive impressive adoption rates.",
    projects: [
      { suburb: "South Morang", systemSize: "6.6kW", batterySize: "10kWh", homeType: "New build", savings: 1800, brand: "Jinko Solar + Deye" },
      { suburb: "Mernda", systemSize: "8kW", batterySize: "13.5kWh", homeType: "Double-storey", savings: 2050, brand: "Jinko Solar + WHES" },
      { suburb: "Doreen", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Family home", savings: 1750, brand: "Jinko Solar + Sigenergy" }
    ]
  },
  "wyndham": {
    name: "Wyndham",
    slug: "wyndham",
    region: "Western Growth Corridor",
    suburbs: ["Werribee", "Point Cook", "Tarneit", "Truganina", "Williams Landing", "Hoppers Crossing"],
    solarAdoption: 48,
    annualSavings: 1800,
    billReduction: 76,
    batteryGrowth: 52,
    avgSystemSize: "6.6kW",
    avgBatterySize: "10kWh",
    housingType: "New housing estates",
    description: "Wyndham has the highest solar adoption rate in metropolitan Melbourne. The booming western corridor is leading Victoria's clean energy transition.",
    whySolar: "Wyndham residents are Victoria's solar champions. New housing estates, hot summers, and a community committed to savings make this area ideal for solar investment.",
    projects: [
      { suburb: "Point Cook", systemSize: "6.6kW", batterySize: "10kWh", homeType: "New build", savings: 1850, brand: "Jinko Solar + Deye" },
      { suburb: "Tarneit", systemSize: "8kW", batterySize: "13.5kWh", homeType: "Double-storey", savings: 2100, brand: "Jinko Solar + WHES" },
      { suburb: "Werribee", systemSize: "6.6kW", batterySize: "10kWh", homeType: "Family home", savings: 1750, brand: "Jinko Solar + Sigenergy" }
    ]
  },
  "yarra": {
    name: "Yarra",
    slug: "yarra",
    region: "Inner Melbourne",
    suburbs: ["Richmond", "Collingwood", "Fitzroy", "Abbotsford", "Clifton Hill", "Cremorne"],
    solarAdoption: 21,
    annualSavings: 1550,
    billReduction: 52,
    batteryGrowth: 45,
    avgSystemSize: "5kW",
    avgBatterySize: "10kWh",
    housingType: "Inner-city terraces and warehouses",
    description: "Yarra's progressive inner-city suburbs are at the forefront of urban solar innovation. Heritage buildings and converted warehouses are being transformed with solar.",
    whySolar: "Yarra residents lead Melbourne's sustainability movement. Despite heritage constraints and smaller roof spaces, innovative solutions are bringing solar to this iconic area.",
    projects: [
      { suburb: "Richmond", systemSize: "5kW", batterySize: "10kWh", homeType: "Terrace", savings: 1500, brand: "Jinko Solar + Sigenergy" },
      { suburb: "Fitzroy", systemSize: "5kW", batterySize: "10kWh", homeType: "Warehouse conversion", savings: 1600, brand: "Jinko Solar + Deye" },
      { suburb: "Collingwood", systemSize: "6.6kW", batterySize: null, homeType: "Period home", savings: 1350, brand: "Jinko Solar" }
    ]
  },
  "yarra-ranges": {
    name: "Yarra Ranges",
    slug: "yarra-ranges",
    region: "Outer-East Melbourne",
    suburbs: ["Lilydale", "Mount Evelyn", "Belgrave", "Healesville", "Yarra Glen", "Mooroolbark"],
    solarAdoption: 36,
    annualSavings: 2000,
    billReduction: 70,
    batteryGrowth: 55,
    avgSystemSize: "8kW",
    avgBatterySize: "13.5kWh",
    housingType: "Hills and rural properties",
    description: "Yarra Ranges' stunning natural environment inspires residents to embrace sustainable energy. Larger properties and environmental values drive strong solar adoption.",
    whySolar: "Yarra Ranges residents live in harmony with nature and naturally choose clean energy. Larger blocks and the desire for energy independence make this area perfect for solar and battery systems.",
    projects: [
      { suburb: "Lilydale", systemSize: "8kW", batterySize: "13.5kWh", homeType: "Family home", savings: 2100, brand: "Jinko Solar + Tesla Powerwall" },
      { suburb: "Belgrave", systemSize: "10kW", batterySize: "13.5kWh", homeType: "Hills property", savings: 2400, brand: "Jinko Solar + WHES" },
      { suburb: "Healesville", systemSize: "10kW", batterySize: "10kWh", homeType: "Rural property", savings: 2300, brand: "Jinko Solar + Sigenergy" }
    ]
  }
};

// Helper to get all councils as array
export const getAllCouncils = () => Object.values(councilData);

// Helper to get council by slug
export const getCouncilBySlug = (slug) => councilData[slug];

// List of all council slugs for routing
export const councilSlugs = Object.keys(councilData);
